import { ActionTree } from "vuex";
import { HomeState } from "../types";

const actions: ActionTree<HomeState, any> = {
  promptForCancel({ commit }, isCancelling = false) {
    commit("setPromptForCancel", isCancelling);
    return isCancelling;
  },
};

export default actions;
